import { useState, type ReactNode } from "react";
import { sectionCardClass } from "@/components/manufacturing/manufacturingSurfaceClasses";

export function QcDashboardFold({
  title,
  defaultOpen,
  children,
}: {
  title: string;
  defaultOpen: boolean;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className={sectionCardClass}>
      <button
        type="button"
        className="flex w-full items-center justify-between gap-2 text-left"
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        <h3 className="text-base font-semibold text-gray-900 dark:text-zinc-100">{title}</h3>
        <span className="text-sm text-gray-600 dark:text-zinc-400">{open ? "Hide" : "Show"}</span>
      </button>
      {open ? children : null}
    </section>
  );
}
